/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_VestingTypeDto } from '../models/PagedResultDto_VestingTypeDto';
import type { Wealthlane_AwardService_Dtos_VestingType_CreateUpdateVestingTypeDto } from '../models/Wealthlane_AwardService_Dtos_VestingType_CreateUpdateVestingTypeDto';
import type { Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto } from '../models/Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTypeService {

    /**
     * @returns Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingTypeVestingTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-type/vesting-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingType(
requestBody?: Wealthlane_AwardService_Dtos_VestingType_CreateUpdateVestingTypeDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_VestingTypeDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingType(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_VestingTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-type',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppVestingType(
id: string,
requestBody?: Wealthlane_AwardService_Dtos_VestingType_CreateUpdateVestingTypeDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/vesting-type/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppVestingType(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/vesting-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingType1(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingType_VestingTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
